var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn",attrs:{"type":"submit","disabled":_vm.isLoading}},[(_vm.isLoading)?[_c('span',{staticClass:"spinner-border spinner-border-sm",attrs:{"role":"status"}}),_vm._v(" Submitting... ")]:[_vm._t("default")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }